// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "tire-recommender" + "." + "34f39ae4302bcb1f4c8c" + ".min.js";
};